'use client'
import { useEffect, useState } from 'react'

import { SyneriseFormEvent, syneriseSendFormData } from 'lib/synerise'
import Button from 'shared/ui/Button'
import Input from 'shared/ui/form/Input'
import Link from 'shared/ui/Link/Link'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'
import { PATHS } from 'shared/utils/paths'

import { resetPassword } from '../api/auth'
import {
  validateResetField,
  validateResetValues
} from '../validation/resetPasswordSchema'

import styles from './ForgotPasswordForm.module.scss'

const defaultValues = {
  email: ''
}

const ForgotPasswordForm = () => {
  const [values, setValues] = useState(defaultValues)
  const [valid, setValid] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [validationReset, setValidationReset] = useState(0)

  const handleValueChange = (name: string, value: string) => {
    setValues(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      await resetPassword({ email: values.email?.toLowerCase() })
      setValues(defaultValues)
      toast.success('Email do resetu hasła został wysłany na Twoją skrzynkę')
      syneriseSendFormData({
        formData: {
          email: values.email?.toLowerCase()
        },
        event: SyneriseFormEvent.RESET_PASSWORD
      })
      setIsLoading(false)
      setValidationReset(prev => prev + 1)
    } catch (err) {
      console.error(err)
      toast.error(getApiErrors(err))
      setIsLoading(false)
      setValidationReset(prev => prev + 1)
    }
  }

  useEffect(() => {
    values && validateResetValues(values, setValid)
  }, [values])

  return (
    <form noValidate className={styles.formWrapper} onSubmit={handleSubmit}>
      <div className={styles.formHeader}>Odzyskaj hasło</div>
      <div className={styles.description}>
        Na podany adres email wyślemy Ci instrukcje dotyczące resetowania hasła.
      </div>
      <Input
        required
        value={values.email}
        name='email'
        label='Email'
        resetValidationTrigger={validationReset}
        onChange={handleValueChange}
        validate={validateResetField(values)}
      />
      <div className={styles.buttonsWrapper}>
        <Button
          fullWidth
          variant='primary'
          size='large'
          type='submit'
          disabled={!valid || isLoading}
        >
          Zresetuj hasło
        </Button>
        <div className={styles.noAccount}>
          Przypomniałeś sobie hasło? <Link href={PATHS.login}>Zaloguj się</Link>
        </div>
      </div>
    </form>
  )
}

export default ForgotPasswordForm
